import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { DropzoneComponent, DropzoneComponentConfig, DropzoneComponentHandlers, DropzoneComponentProps } from 'react-dropzone-component';
import * as Dropzone from 'dropzone';
import { Tabs, Tab } from 'react-bootstrap';
import ReactJson from 'react-json-view';

interface PDFUploadResult {
    success: boolean;
    error: boolean;
    errorMessage: string;
    jsonData: any;
    successMessage: string;
    warning: boolean,
    warningMessage: string,
    token: string,
    cacheClear:boolean
}


export class MergePDF extends React.Component<RouteComponentProps<{}>, PDFUploadResult> {
    private djsConfig: any = {};
    private eventHandler: DropzoneComponentHandlers = {};
    private componentConfig: DropzoneComponentConfig = {};
    private myDropzone: any = null;
    private dataUrl: string = 'api/pdfmerge/filldataintopdf';
    private downloadpdfUrl: string = 'api/pdfmerge/downloadmergepdf';
    private dropzone: Dropzone;
    private style: any = {
        'margin-top': '10px',
        'max-height': '250px',
        'min-height': '250px',
        'overflow-y': 'scroll'
    };
    private leftmaringstyle: any = {
        'margin-left':'10px'
    }

    constructor(props: any) {
        super(props);

        this.handleEditRequest = this.handleEditRequest.bind(this);
        this.handleRawJsonChange = this.handleRawJsonChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.init = this.init.bind(this);
        this.handleError = this.handleError.bind(this);
        this.sending = this.sending.bind(this);
        this.tokenChanges = this.tokenChanges.bind(this);
        this.handleClearCache = this.handleClearCache.bind(this);
        this.state = {
            success: false,
            error: false,
            errorMessage: "",
            successMessage: "",
            warning: false,
            warningMessage: "",
            jsonData: {},
            token: "",
            cacheClear: false
        }

        this.djsConfig = {
            addRemoveLinks: false,
            acceptedFiles: ".pdf",
            uploadMultiple: false,
            maxFiles: 1,
            autoProcessQueue: false,
            paramName: "pdfform"
        }

        this.componentConfig = {
            showFiletypeIcon: true,
            iconFiletypes: ['.pdf'],
            postUrl: this.dataUrl
        }

        this.eventHandler = {
            success: this.handleSuccess,
            init: this.init,
            error: this.handleError,
            sending: this.sending
        }

    }

    private init(passedDropzone: Dropzone) {
        console.log("init called");
        this.dropzone = passedDropzone;
        this.setState({ success: false, error: false });
    }

    private handleSuccess(file: any, response: any) {
        if (response.success == "True") {
            if (response.showWarningMessage == "True") {
                this.setState({ success: true, error: false, successMessage: response.processId, warning: true, warningMessage: response.warningMessage });
            } else {
                this.setState({ success: true, error: false, successMessage: response.processId });
            }
        }
        else {
            if (response.showWarningMessage == "True") {
                this.setState({ success: false, error: true, successMessage: response.message, warning: true, warningMessage: response.warningMessage });
            } else {
                this.setState({ success: false, error: true, errorMessage: response.message });
            }
        }

        this.dropzone.removeAllFiles(true);
    }

    private sending(file: any, xhr: any, formdata: FormData) {
        formdata.append("Data", JSON.stringify(this.state.jsonData));
    }

    private handleError(file: any, errorMessage: string) {
        this.setState({ success: false, error: true, errorMessage: errorMessage });
        this.dropzone.removeAllFiles(true);
    }

    public render() {
        return <div>
            <div className="page-header">
                <h3>Merge PDF</h3>
            </div>
            {
                this.state.success ?
                    <div className="row alert alert-success mt-5">
                        PDF Genereated Successfully. Download Generated PDF Click <a href={this.downloadpdfUrl + "?processid=" + this.state.successMessage} target="_blank">here</a>
                    </div> : null
            }

            {
                this.state.cacheClear ?
                    <div className="row alert alert-success mt-5">
                        {this.state.successMessage}
                    </div> : null
            }

            {
                this.state.warning ?
                    <div className="row alert alert-warning mt-5">
                        {this.state.warningMessage}
                    </div> : null
            }

            {
                this.state.error ?
                    <div className="row alert alert-danger mt-5">
                        {this.state.errorMessage}
                    </div> : null
            }
            <div className="form-group">
                <label>Select PDF File:</label>
                <DropzoneComponent config={this.componentConfig} eventHandlers={this.eventHandler} djsConfig={this.djsConfig} />
            </div>
            <div className="form-group">
                <label>Token: <i className="glyphicon glyphicon-question-sign" title="If uploaded pdf contains Translator decorators, then token is required"></i></label>
                <input type="text" placeholder="Token" id="Token" className="form-control" onChange={this.tokenChanges} />
            </div>
            <div className="form-group">
                <label>PDF Data:</label>
                <Tabs defaultActiveKey={1} id="apirequesttabs">
                    <Tab eventKey={1} title="Raw View">
                        <textarea value={JSON.stringify(this.state.jsonData)} className="form-control" onChange={this.handleRawJsonChange} rows={11}>
                        </textarea>
                    </Tab>
                    <Tab eventKey={2} title="JSON View">
                        <div className="row" style={this.style}>
                            <div className="col-sm-11">
                                <ReactJson src={this.state.jsonData} onEdit={(edit) => { this.handleEditRequest(edit) }} onAdd={(add) => { this.handleEditRequest(add) }} onDelete={(deleteobj) => { this.handleEditRequest(deleteobj) }} name="Data" />
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </div>
            <button type="button" className="btn btn-primary" onClick={this.handleSubmit}>Generate PDF</button>
            <button type="button" className="btn btn-primary" onClick={this.handleClearCache} style={this.leftmaringstyle}>Clear Memory Cache</button>
        </div>;
    }

    private handleEditRequest(editdata: any) {
        this.setState({
            jsonData: editdata.updated_src
        });
    }

    private tokenChanges(e: any) {
        this.setState({
            token: e.target.value
        });

        if (e.target.value != "") {
            this.djsConfig.headers = {
                'Authorization': 'Bearer ' + e.target.value
            }
        }
    }

    private handleRawJsonChange(e: any) {
        this.setState({
            jsonData: JSON.parse(e.target.value)
        });
    }

    private handleSubmit(e: any) {
        this.setState({ success: false, error: false, warning: false });
        if (this.dropzone.getAcceptedFiles().length > 0) {
            this.dropzone.processQueue();
        }
        else {
            this.setState({
                error: true,
                success: false,
                errorMessage: "Please select PDF File",
                warning: false
            });
        }
    }

    private handleClearCache(e: any) {
        fetch('api/diagnostic/ClearCache')
            .then(response => response.json())
            .then(data => {
                this.setState({ success: false, error: false, successMessage: "Cache successfully refreshed.", cacheClear:true });
            });
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/MergePDF.tsx